import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QualComponent } from './qual.component';
import { ReportDetailsComponent } from '../repository/report-details/report-details.component';
import { FileViewerComponent } from '../repository/file-viewer/file-viewer.component';
import { QualListComponent } from './qual-list/qual-list.component';
import { TableExtractionComponent } from '../repository/table-extraction/table-extraction.component';
import { ViewAiDiscussionGuidComponent } from '../shared-repository/view-ai-discussion-guid/view-ai-discussion-guid.component';

const routes: Routes = [
  {
    path:'',
    component:QualComponent,
    children:[
      {path:'',component:QualComponent},
      { path: 'interview/:uuid', component: QualListComponent },
      { path: 'discussion-guide/:uuid', component: ViewAiDiscussionGuidComponent },
      { path: 'report/:uuid', component: ReportDetailsComponent },
      { path: 'reports/file-view/:uuid', component: FileViewerComponent },
      // { path: 'table-extraction/:uuid', component: TableExtractionComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QualRoutingModule { }
